import Api from './Api'

export default {
  setupCounter(data) {
    return Api().post('/setupCounters', data)
  },
}
